import React from "react";
import ReactDOM from "react-dom/client";
import Mining from "./mining";
import "../../index.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Mining />
  </React.StrictMode>,
);
